import { ReactComponent as TriangleAlert } from "assets/images/iconsV2/triangle-alert.svg";
import Badge from "components/v2/Badge/Badge";

import "./FieldErrorBadge.scss";

interface FieldErrorBadgeProps {
  message: string;
}

export default function FieldErrorBadge({ message }: FieldErrorBadgeProps) {
  return (
    <div className="rfv2-field-error-badge">
      <Badge
        type="category-badge"
        size="sm"
        color="error"
        variant="icon-leading"
        icon={<TriangleAlert className="rfv2-field-error-badge__icon" />}
        label={message}
      />
    </div>
  );
}
